import React, {FC, ReactNode} from "react";

interface HeaderProps {
  children: ReactNode
}

export const PageHeader: FC<HeaderProps> = props => {
  return <h1 className={"min-h-12 py-2 flex items-center text-2xl mb-6 font-bold"}>
    {props.children}
  </h1>
}